import { defineWorld } from "@latticexyz/world";

export default defineWorld({
  namespace: "REAP",
  tables: {
    ToggleTable: {
      schema: {
        smartObjectId: "uint256",
        isSet: "bool"
      },
      key: ["smartObjectId"],
    },
    Corps: {
      schema: {
        corpId: "uint256",
        corpName: "string"
      },
      key: ["corpId"],
    },
    Admins: {
      schema: {
        corpId: "uint256",
        smartCharacterId: "address",
        characterName: "string"
      },
      key: ["corpId", "smartCharacterId"],
    },
    RiderPoints: {
      schema: {
        smartCharacterId: "address",
        isCorpRider: "bool",
        points: "uint256",
        riderName: "string",
      },
      key: ["smartCharacterId"],
    },
    RiderPointsTxn: {
      schema: {
        smartCharacterId: "address",
        txnAt: "uint256",
        points: "int256",
        txnDescription: "string",        
      },
      key: ["smartCharacterId", "txnAt"],
    },
    TuckSellItem: {
      schema: {
        inventoryItemId: "uint256",
        isCorpRate: "bool",
        points: "uint256",
        inventoryItemName: "string",        
      },
      key: ["inventoryItemId", "isCorpRate"],
    },
    TuckBuyItem: {
      schema: {
        inventoryItemId: "uint256",
        isCorpRate: "bool",
        points: "uint256",
        inventoryItemName: "string",
      },
      key: ["inventoryItemId", "isCorpRate"],
    },
    GateAccessToken: {
      schema: {
        smartCharacterId: "address",
        points: "uint256",
        characterName: "string",
      },
      key: ["smartCharacterId"],
    },
  },
});
